import { Box, Button, Typography } from '@mui/material'
import { useContext } from 'react'

import { Modal } from '../../../components/Modal/Modal'
import {
  ResourcesContext,
  ResourcesContextInterface,
  rootResourceFolder,
} from '../../../providers/Resources/Resources.provider'
import { ResourceFile, ResourceFolder, ResourceItem } from './Resources.view'

interface DeleteResourceModalInterface {
  currentFolder: ResourceFolder | null
  deleteModalOpen: boolean
  setDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  deleteFolderOrFile: ResourceFolder | rootResourceFolder | ResourceFile | null
  setDeleteFolderOrFile: React.Dispatch<
    React.SetStateAction<
      ResourceFolder | ResourceFile | rootResourceFolder | null
    >
  >
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  fetchFolderContent: (folderId: number) => Promise<void>
}

export const DeleteResourceModal = ({
  currentFolder,
  deleteModalOpen,
  setDeleteModalOpen,
  deleteFolderOrFile,
  setDeleteFolderOrFile,
  loading,
  setLoading,
  fetchFolderContent,
}: DeleteResourceModalInterface) => {
  const { deleteResourceFolder, deleteResourceFile, getRootResourceFolders } =
    useContext(ResourcesContext) as ResourcesContextInterface

  return (
    <Modal
      title='Delete'
      open={deleteModalOpen}
      setOpen={setDeleteModalOpen}
      ModalContent={
        <Box sx={{ p: 2 }}>
          <Typography
            style={{
              justifySelf: 'center',
              marginBottom: '10px',
            }}
          >
            Are you sure to delete{' '}
            {deleteFolderOrFile?.type === 'folder' ? 'folder' : 'file'}{' '}
            {deleteFolderOrFile?.name} ?
          </Typography>

          <Box
            sx={{
              mt: 2,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              onClick={() => setDeleteModalOpen(false)}
              variant='outlined'
              color='error'
              disabled={loading}
              sx={{ marginRight: 1 }}
            >
              <Typography fontSize={13}>Cancel</Typography>
            </Button>
            <Button
              onClick={async () => {
                setLoading(true)
                if (deleteFolderOrFile) {
                  if (deleteFolderOrFile.type === 'folder') {
                    await deleteResourceFolder(deleteFolderOrFile.id)
                  } else {
                    await deleteResourceFile(
                      deleteFolderOrFile.id,
                      deleteFolderOrFile.folderId
                    )
                  }
                }
                setDeleteFolderOrFile(null)

                if (currentFolder) {
                  fetchFolderContent(currentFolder.id)
                } else {
                  await getRootResourceFolders()
                  setLoading(false)
                }
                setDeleteModalOpen(false)
              }}
              variant='contained'
              color='error'
              disabled={loading}
            >
              <Typography fontSize={13}>Delete</Typography>
            </Button>
          </Box>
        </Box>
      }
    />
  )
}
